import PropTypes from "prop-types";
import React, {Fragment, useEffect, useState} from "react";
import { connect } from "react-redux";
import ProductGridSingleTwo from "../../components/product/ProductGridSingleTwo";
import { addToCart } from "../../redux/actions/cartActions";
import { addToWishlist } from "../../redux/actions/wishlistActions";
import { addToCompare } from "../../redux/actions/compareActions";
import axios from "axios";

const ProductGridTwo = ({
  type,
  currency,
  addToCart,
  addToWishlist,
  addToCompare,
  cartItems,
  wishlistItems,
  compareItems,
  sliderClassName,
  spaceBottomClass,
  colorClass,
  titlePriceClass,
  shopType,
  origin
}) => {

  const [products, setProducts] = useState({ products: [] });
  const [error, setError] = useState('');
  const [loading, setloading] = useState(true);

  const fetchData = (type, origin) => {
    if (origin && origin == "be"){
      origin = "fr"
    }

    let query
    if (type && type !== "") {
      if (shopType!== ""){
        query = 'https://api.therunningcollective.fr/api/public/new-products?lang='+origin+'&shopType='+shopType+'&sortType='+type
      } else {
        query = 'https://api.therunningcollective.fr/api/public/new-products?lang='+origin+'&sortType='+type
      }
    } else {
      if (shopType!== ""){
        query = 'https://api.therunningcollective.fr/api/public/new-products?lang='+origin+'&shopType='+shopType
      } else {
        query = 'https://api.therunningcollective.fr/api/public/new-products?lang='+origin
      }
    }

    axios
        .get(query)
        .then((res) => {
          setProducts(res.data);
        })
        .catch((err) => {
          setError(err);
        })
        .finally(() => {
          setloading(false);
        });
  };

  useEffect(() => {
    fetchData(type, origin);
  }, [type, origin]);

  return (
    <Fragment>
      {!loading ? products && products.length >0 ? products.map((product) => {
        if(product.showProduct) {
          return (
              <ProductGridSingleTwo
                  sliderClassName={sliderClassName}
                  spaceBottomClass={spaceBottomClass}
                  colorClass={colorClass}
                  product={product}
                  currency={currency}
                  addToCart={addToCart}
                  addToWishlist={addToWishlist}
                  addToCompare={addToCompare}
                  cartItem={
                    cartItems.filter((cartItem) => cartItem.id === product.id)[0]
                  }
                  wishlistItem={
                    wishlistItems.filter(
                        (wishlistItem) => wishlistItem.id === product.id
                    )[0]
                  }
                  compareItem={
                    compareItems.filter(
                        (compareItem) => compareItem.id === product.id
                    )[0]
                  }
                  key={product.id}
                  titlePriceClass={titlePriceClass}
              />
          );
        }
      }) : <span>Aucun produit disponible</span> : <span>Chargement en cours</span> }
      {error ? <span>Erreur durant le chargement des données</span> : null }
    </Fragment>
  );
};

ProductGridTwo.propTypes = {
  addToCart: PropTypes.func,
  addToCompare: PropTypes.func,
  addToWishlist: PropTypes.func,
  cartItems: PropTypes.array,
  compareItems: PropTypes.array,
  currency: PropTypes.object,
  sliderClassName: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  colorClass: PropTypes.string,
  titlePriceClass: PropTypes.string,
  wishlistItems: PropTypes.array,
  shopType: PropTypes.string,
  origin: PropTypes.string
};

const mapStateToProps = (state, ownProps) => {

  return {
    type: ownProps.type,
    currency: state.currencyData,
    cartItems: state.cartData,
    wishlistItems: state.wishlistData,
    compareItems: state.compareData
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (
      item,
      addToast,
      quantityCount,
      selectedProductColor,
      selectedProductSize
    ) => {
      dispatch(
        addToCart(
          item,
          addToast,
          quantityCount,
          selectedProductColor,
          selectedProductSize
        )
      );
    },
    addToWishlist: (item, addToast) => {
      dispatch(addToWishlist(item, addToast));
    },
    addToCompare: (item, addToast) => {
      dispatch(addToCompare(item, addToast));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductGridTwo);
